/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/fish_medium'
export default icon
